<template>
    <uw-content title="周报管理">
        <template slot="prefix">
            <el-button size="mini" :type="search.status === null ? 'primary' : 'text'" @click="search.status = null; TableSearch()">全部</el-button>
            <el-button size="mini" :type="search.status === 0 ? 'primary' : 'text'" @click="search.status = 0; TableSearch()">待确认</el-button>
            <el-button size="mini" :type="search.status === 1 ? 'primary' : 'text'" @click="search.status = 1; TableSearch()">已确认</el-button>
        </template>
        <template slot="suffix">
            <el-button type="primary" size="mini" @click="OpenGenerate()">生成周报</el-button>
        </template>

        <uw-table>
            <template slot="search">
                <users-select v-model="search.users_id" multiple placeholder="成员" @onChange="TableSearch" />
                <el-date-picker
                    v-model="search.range_at"
                    @change="TableSearch"
                    size="mini"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    unlink-panels
                    range-separator="至"
                    start-placeholder="周期开始"
                    end-placeholder="周期结束">
                </el-date-picker>
            </template>
            <template slot="data">
                <vxe-table ref="xTable" :data="table" :loading="loading" height="100%">
                    <vxe-column width="100" title="状态" align="center">
                        <template #default="{ row }">
                            <el-tag v-if="!row.confirmed_at" type="warning" effect="dark" size="small">待确认</el-tag>
                            <el-tag v-else type="success" effect="dark" size="small">已确认</el-tag>
                        </template>
                    </vxe-column>
                    <vxe-column width="140" title="成员">
                        <template #default="{ row }">
                            <div style="display: flex; align-items: center; justify-content: flex-start;">
                                <el-avatar style="margin-right: 5px;" :size="26" :src="row.users?.avatar">{{ row.users?.name ? row.users.name[0] : '' }}</el-avatar>
                                {{ row.users?.name }}
                            </div>
                        </template>
                    </vxe-column>
                    <vxe-column width="250" title="汇报周期">
                        <template #default="{ row }">
                            <span>
                                {{ FormatWeek(row.work_start) }} 至 {{ FormatWeek(row.work_end) }}
                            </span>
                        </template>
                    </vxe-column>
                    <vxe-column min-width="480" title="周报摘要">
                        <template #default="{ row }">
                            {{ Preview(row.content_display || row.content_confirmed || row.content_ai) }}
                        </template>
                    </vxe-column>
                    <vxe-column width="160" title="推送时间" field="notified_at"></vxe-column>
                    <vxe-column width="160" title="确认时间" field="confirmed_at"></vxe-column>
                    <vxe-column width="160" title="操作" align="center" fixed="right">
                        <template #default="{ row }">
                            <span class="el-span-primary" @click="OpenDetail(row.id)">查看</span>
                        </template>
                    </vxe-column>
                </vxe-table>
            </template>
            <template slot="pager">
                <vxe-pager :total="page.total" :page-size.sync="page.size" :current-page.sync="page.current" @page-change="TableSearch()"></vxe-pager>
            </template>
        </uw-table>

        <pm-weekly-report-drawer ref="drawer" @onChange="TableSearch" />
        <pm-weekly-report-generate ref="generate" @onChange="TableSearch" />
    </uw-content>
</template>

<script>
export default {
    data () {
        return {
            table: [],
            page: {
                total: 0,
                size: 20,
                current: 1
            },
            search: {
                status: null,
                type: 1,
                users_id: [],
                range_at: null
            },
            order: {
                method: 'desc',
                column: 'work_start'
            },
        }
    },
    computed: {
        loading () {
            return !!this.$store.state.httpRequestCount
        }
    },
    mounted () {
        this.TableSearch()
    },
    methods: {
        FormatWeek (value) {
            if (!value) return ''
            return String(value).substring(0, 10)
        },
        Preview (content) {
            if (!content) return '-'
            const text = String(content).replace(/\s+/g, ' ').trim()
            return text.length > 120 ? text.substring(0, 120) + '...' : text
        },
        TableSearch () {
            return this.$http.post('/9api/pm/weekly-report/search', {
                page: this.page,
                search: this.search,
                order: this.order,
                append: ['users', 'status', 'status_text', 'content_display']
            }).then(res => {
                this.table = res.data.data || []
                this.page.total = res.data.total || 0
            })
        },
        OpenDetail (id) {
            this.$refs.drawer.Open(id)
        },
        OpenGenerate () {
            this.$refs.generate.Open()
        }
    }
}
</script>
